import { Plugin } from './index';

export const addAuthHeader: Plugin = {
  transformRequest: (req) => {
    const storedToken = localStorage.getItem('kl.jwtToken');

    if (!storedToken) {
      throw new Error(`${req.url}: No token available`);
    }

    try {
      req.headers.set('Authorization', `Bearer ${JSON.parse(storedToken)}`);
    } catch (err) {
      throw new Error('Could not decode and set token');
    }

    return req;
  },
};

export const throwOnResponse: Plugin = {
  transformResponse: async (res) => (res.ok ? res : Promise.reject(res)),
};

export const addCookiesToRequest: Plugin = {
  transformRequest: (req) => new Request(req, { credentials: 'include' }),
};
